import { createFrontendPlugin, FrontendPlugin } from '@backstage/frontend-plugin-api'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

import { rootRouteRef } from './routes';


const FastlyComplianceComponent = EntityContentBlueprint.make({
  name: 'FastlyComplianceComponent',
  params: {
    path: 'compliance',
    title: 'Compliance',
    filter: (entity) => entity.kind === 'Component' && (entity.spec?.type === 'service' || entity.spec?.type === 'repository'),
    loader: () => import('./components/ComplianceContent').then(m => <m.ComplianceContent />)
  },
})

const fastlyCompliancePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'fastly-compliance',
  routes: {
    root: rootRouteRef,
  },
  extensions: [FastlyComplianceComponent],
})

export default fastlyCompliancePlugin
